/**
 * @generated SignedSource<<3cd74388df1b6be8abbf33ee0c9362bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMarketSettings_viewer$data = {
  readonly isNftAuctionV2Enabled: boolean | null;
  readonly " $fragmentType": "useMarketSettings_viewer";
};
export type useMarketSettings_viewer$key = {
  readonly " $data"?: useMarketSettings_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMarketSettings_viewer",
  "selections": [
    {
      "alias": "isNftAuctionV2Enabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftAuctionV2"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1577571309b7108580e4d227e186a175";

export default node;
